import EmbeddedContainer from '../../containers/Embedded';

const RouteEmbeddedContainer = () => {
    return <EmbeddedContainer />;
};

export default RouteEmbeddedContainer;
